export default { getPdfData: state => state.pdfData }
